import { useEffect, useRef } from "react"
import moment from "moment-timezone"
import { momentDateTime } from "utils/dates"
import { array, bool, func, oneOfType, string } from "prop-types"

const DesktopTimePicker = ({
  datetime,
  twentyFourHourTime,
  name,
  classNames,
  id,
  style,
  onChange
}) => {
  const inputRef = useRef(null)
  const { momentTimeFormat } = App.currentOrganization

  useEffect(() => {
    const $input = $(inputRef.current)

    if (twentyFourHourTime) {
      $input.timepicker({ timeFormat: "H:i" })
    } else {
      $input.timepicker()
    }

    return () => {
      $input.timepicker("remove")
    }
  }, [])

  useEffect(() => {
    const $input = $(inputRef.current)

    const value = datetime === null ? null : moment(datetime).format(momentTimeFormat)
    $input.val(value)
    $input.off("change")
    $input.on("change", ({ target: { value: time } }) => {
      if (onChange) {
        onChange(momentDateTime(datetime, time).format())
      }
    })
  }, [datetime])

  return (
    <input
      ref={inputRef}
      type="text"
      defaultValue={moment(datetime).format(momentTimeFormat)}
      name={name}
      id={id}
      className={classNames}
      style={style}
    />
  )
}

DesktopTimePicker.propTypes = {
  datetime: string,
  twentyFourHourTime: bool,
  name: string,
  classNames: oneOfType([string, array]),
  id: string,
  style: string,
  onChange: func
}

export default DesktopTimePicker
